import React from 'react'
import UsersChartLine from './UsersChartLine'

export default function UsersChartLineApproved() {
  return <UsersChartLine status={'Approved'} />
}
